import http from '@util/http';
import { project } from './req.js';

export async function queryProjectList(params) {
  return http.get(project.GET_PROTECTION_LIST, params);
}

export async function queryProjectInfo(params) {
  return http.get(project.GET_PROTECTION_INFO, params);
}

export async function queryAgreeProject(params) {
  return http.post(project.AGREE_PROTECTION, params);
}

export async function queryRefuseProject(params) {
  return http.post(project.REFUSE_PROTECTION, params);
}



// WEBPACK FOOTER //
// ./src/api/protect.js